import dayjs from 'dayjs';

export function getRemainingTime(time, withTime) {
  if (time === -1) return -1;

  const now = dayjs();
  const add = withTime ? '' : '000';

  const date = dayjs(parseInt(time + add));
  const diff = date.diff(now, 'day', true);

  // округляем в большую сторону
  return diff <= 0 ? 0 : Math.ceil(diff);
}
